import * as v from 'valibot';
import Ajax from '../util/ajax';
import { zigbeeNodeNeighborUpdated } from '../features/zigbee_node_neighbors/zigbeeNodeNeighborsSlice';
import { neighborsSchema } from '../types/Zigbee/Neighbors';
export function fetchZigbeeNodeNeighbors(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/lqi';
        ajax.post(url, {}, data => {
            const res = v.safeParse(neighborsSchema, data);
            if (res.success) {
                const neighbors = res.output;
                dispatch(zigbeeNodeNeighborUpdated({ node_id: zigbee_node_id, neighbors }));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
